import { useState, useEffect } from "react";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import SubTitle from "../../../components/SubTitle";

interface Props {
  message: string;
}

const FadingText = ({ message }: Props) => {
  const [fadeIn, setFadeIn] = useState(false);
  const [text, setText] = useState("");

  useEffect(() => {
    setFadeIn(false);
    setTimeout(() => {
      setText(message);
      setFadeIn(true);
    }, 300);
  }, [message]);

  return (
    <Fade in={fadeIn}>
      <Box sx={{ textAlign: "center" }}>
        <SubTitle sx={{fontWeight: 600, fontSize: "18px", color: "#655B50"}}>{text}</SubTitle>
      </Box>
    </Fade>
  );
};
export default FadingText;
